export const DOCUMENTS_TABLE = {
    'DOCUMENTS.COLUMN.CLIENT_NAME': 'Nume client',
    'DOCUMENTS.COLUMN.COMPANY_NAME': 'Nume companie',
    'DOCUMENTS.COLUMN.DOCUMENT_NAME': 'Nume document',
    'DOCUMENTS.COLUMN.DOCUMENT_CATEGORY': 'Categorie document',
    'DOCUMENTS.COLUMN.NUMBER_OF_CALCULATIONS': 'Calcule',
    'DOCUMENTS.COLUMN.UPLOAD_DATE': 'Dată încărcare',
    'DOCUMENTS.COLUMN.SIZE': 'Dimensiune MB',
    'DOCUMENTS.COLUMN.UPDATED_BY': 'Actualizat de',
    'DOCUMENTS.COLUMN.ACTIONS': 'Acțiuni',
    'DOCUMENTS.COLUMN.ATTACHED_DOCUMENT_NAME': 'Denumire document adăugat',
    'DOCUMENTS.SEARCH_PLACEHOLDER': 'Caută Client/Companie/Nume',
    'DOCUMENTS.ACTION.ADD': 'Document nou',
    'DOCUMENTS.ACTION.DOWNLOAD': 'Descarcă document',
    'DOCUMENTS.ACTION.DETAILS': 'Detalii document',
    'DOCUMENTS.ACTION.DELETE': 'Șterge document',
    'DOCUMENTS.FILTER.STATUS': 'Asociat calcule'
};
